import React, { useState } from 'react';
import Nav from '../Home/Nav/Nav.js';
import { FaLongArrowAltLeft, FaStar } from "react-icons/fa";
import { Link as RouterLink } from 'react-router-dom';
import './Review.css';
import { HOST } from "../../../config.js";
import { useTranslation } from 'react-i18next';


const API_URL = HOST; 


const Review = () => {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [reviewText, setReviewText] = useState('');
    const [rating, setRating] = useState(0); 
    const [hoverRating, setHoverRating] = useState(0); 
    const [imageFile, setImageFile] = useState(null);
    const [submissionStatus, setSubmissionStatus] = useState(null); 

      const { t, i18n } = useTranslation();
  
      const changeLanguage = (e) => {
        i18n.changeLanguage(e.target.value);
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (rating === 0) {
            alert("Veuillez donner une note en étoiles.");
            return;
        }

        setSubmissionStatus('pending');

        const formData = new FormData();
        formData.append('first_name', firstName); 
        formData.append('last_name', lastName);
        formData.append('email', email);
        formData.append('review', reviewText);
        formData.append('rating', rating);
        if (imageFile) {
            formData.append('image', imageFile);
        }

        try {
            const response = await fetch(API_URL + 'submit_review.php', {
                method: 'POST',
                body: formData, 
            });

            const data = await response.json();

            if (response.ok && response.status !== 500) { 
                setSubmissionStatus('success');
                setFirstName(''); setLastName(''); setEmail('');
                setReviewText(''); setRating(0); setImageFile(null);
            } else {
                setSubmissionStatus('error');
                console.error("Submission Error:", data.message || "Unknown error");
            }

        } catch (error) {
            setSubmissionStatus('error');
            console.error("Fetch Error:", error);
        }
    };

    const renderStarInputs = () => (
        <div className="flex mb-5"> 
            {[...Array(5)].map((_, index) => {
                const starValue = index + 1;
                const starColor = starValue <= (hoverRating || rating) ? "#CF9242" : "#D9D9D9";
                return (
                    <FaStar
                        key={starValue}
                        size={30}
                        color={starColor}
                        onClick={() => setRating(starValue)}
                        onMouseEnter={() => setHoverRating(starValue)}
                        onMouseLeave={() => setHoverRating(0)}
                        className="cursor-pointer transition-colors duration-200 mr-1.5"
                    />
                );
            })}
        </div>
    );

    return (
        <div>
            <div className='reviewp'>
            <div className='pt-10' ><Nav/></div>
                <div className='reviewp_all'> 
                    <div className='reviewp_titles'>
                        <h1 className='titre'>{t("review.title")}</h1><br></br>
                        <h4 className='plf'>{t("review.subtitle")}</h4>
                    </div>

                    <div className='buttons'>
                        <RouterLink to="/" className='plf reviewp_button2 flex items-center space-x-2'> 
                            <FaLongArrowAltLeft />
                            <span>{t("review.button")}</span>
                        </RouterLink>
                    </div>
                </div>
            </div>
            
            <div className='Review_content'> 
                
                <form 
                    className='flex flex-col px-6 sm:px-10 md:px-24 lg:px-64 xl:px-50 py-12 justify-around' 
                    onSubmit={handleSubmit}
                >
                    
                    <input 
                        type='text' 
                        placeholder={t("review.form_prenom")} 
                        value={firstName} 
                        onChange={(e) => setFirstName(e.target.value)} 
                        required 
                        className=' plf bg-[#F3EFDD] border-t-0 border-l-0 border-r-0 border-b-2 border-black mb-7 pt-7 pb-4 text-base placeholder:text-[#888]'
                    />
                    <input 
                        type='text' 
                        placeholder={t("review.form_nom")} 
                        value={lastName} 
                        onChange={(e) => setLastName(e.target.value)} 
                        required 
                        className=' plf bg-[#F3EFDD] border-t-0 border-l-0 border-r-0 border-b-2 border-black mb-7 pt-7 pb-4 text-base placeholder:text-[#888]'
                    />

                    <input 
                        type='Email' 
                        placeholder={t("review.form_email")}
                        value={email} 
                        onChange={(e) => setEmail(e.target.value)} 
                        required 
                        className=' plf bg-[#F3EFDD] border-t-0 border-l-0 border-r-0 border-b-2 border-black mb-7 pt-7 pb-4 text-base placeholder:text-[#888]'
                    />
                    
                    <label 
                        className='plfrating-label font-bold text-[#243155] mb-2 block mt-2'
                    >
                        {t("review.form_note")}
                    </label>
                    {renderStarInputs()}
                    {rating === 0 && <span className="text-red-500 text-sm mb-5">{t("review.form_note_warnning")}</span>}

                    <label 
                        className='photo-label plf font-bold text-[#243155] mb-2 block'
                    >
                        {t("review.form_photo")}
                    </label>
                    <input 
                        type='File' 
                        onChange={(e) => setImageFile(e.target.files[0])} 
                        className='border border-gray-400 p-2 rounded-md mb-7 text-sm file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-gray-100 hover:file:bg-gray-200'
                    />
                    
                    <textarea 
                        id="Message" 
                        name="Message" 
                        rows="10" 
                        cols="40" 
                        placeholder={t("review.form_commentaire")}
                        value={reviewText}
                        onChange={(e) => setReviewText(e.target.value)} 
                        required
                        className='bg-[#F3EFDD] border-t-0 border-l-0 border-r-0 border-b-2 border-black mb-7 pt-7 pb-4 text-base placeholder:text-[#888] resize-y'
                    />
                    
                    <button 
                        type="submit" 
                        className="plf text-white bg-[#C5A274] border-none rounded-full w-48 py-2.5 text-base font-medium self-center transition duration-300
                                hover:bg-[#CF9242]
                                disabled:bg-gray-400 disabled:cursor-not-allowed"
                        disabled={submissionStatus === 'pending' || rating === 0}
                    >
                        {submissionStatus === 'pending' ? t("review.submission_pending") : t("review.form_button")}
                    </button>

                    {submissionStatus === 'success' && (
                        <p className="text-green-600 font-bold text-center mt-4">
                            {t("review.submission_success")}
                        </p>
                    )}
                    {submissionStatus === 'error' && (
                        <p className="text-red-600 font-bold text-center mt-4">
                            {t("review.submission_error")}
                        </p>
                    )}

                </form>
            </div>
        </div>
    );
}
export default Review